<template>
  <div
    v-if="(enableProAnnualMonthlyPaymentPlanP2 || enableProAnnualWithMonthlyPaymentPre) && isProPlan"
    class="opc-zmone__radio-title-billed-text"
  >
    <span>{{ getBilledText(billingCycle) }}</span>
    <span v-if="isAnnualTermMonthly && showLinkMark">*</span>
  </div>
</template>

<script>
import {
  enableProAnnualMonthlyPaymentPlanP2,
  enableProAnnualWithMonthlyPaymentPre,
  BASE_PLAN_SUB_TYPES,
  BILLING_CYCLE,
} from '@/common/constants';
import simplifyForProMixin from '@/plans/ZOOM_MEETING/mixin/simplify-for-pro.js';

export default {
  mixins: [simplifyForProMixin],
  data() {
    return {
      enableProAnnualMonthlyPaymentPlanP2,
      enableProAnnualWithMonthlyPaymentPre,
    };
  },
  name: 'SubscriptionCycleSubTitle',
  props: {
    billingCycle: {
      type: String,
      required: true,
    },
    currentCategory: {
      type: String,
      required: true,
    },
    showLinkMark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAnnualTermMonthly() {
      return this.billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY;
    },
    isProPlan() {
      return this.currentCategory === BASE_PLAN_SUB_TYPES.PRO;
    },
    getBilledText() {
      return (billingCycle) => {
        if (billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
          return this.$t('billing.bill_monthly');
        } else if (billingCycle === BILLING_CYCLE.ANNUAL) {
          return this.$t('billing.lowercase_prepaid');
        } else {
          return '';
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-zmone__radio-title-billed-text {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  text-transform: lowercase;
  height: 12px;
  color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
}
</style>

<style lang="scss">
.opc-card-radio .zbo-radio__wrap.is-disabled .opc-zmone__radio-title-billed-text {
  color: var(--zoom-color-state-disable, #ADB1B8) !important;
}
</style>
